import React from 'react'

import CheckIcon from '../../assets/icons/check';
import CloseIcon from '../../assets/icons/close';

function INEReport() {
    return (
        <div className="sandbox_report_wrapper">
            <h2>Result report:</h2>
            <p>Esta vigente como medio de identificacion y puede votar</p>
            <div className="api_log_list">
                <h4>Resultado de la Validación</h4>
                <div class="api_log_detail">
                    <span>Clave del Mensaje</span>
                    <span class="api_log_detail_value">3</span>
                </div>
                <div class="api_log_detail">
                    <span>Código de Validación</span>
                    <span class="api_log_detail_value">vi1717171717.070070</span>
                </div>
                <div class="api_log_detail">
                    <span>Estatus</span>
                    <span class="api_log_detail_value">OK</span>
                </div>
            </div>
            <div className="api_log_list">
                <h4>Identificación del Elector</h4>
                <div class="api_log_detail">
                    <span>Clave del Elector</span>
                    <span class="api_log_detail_value">MMMMMM00000000M000</span>
                </div>
                <div class="api_log_detail">
                    <span>Número OCR</span>
                    <span class="api_log_detail_value">0123012301230</span>
                </div>
                <div class="api_log_detail">
                    <span>Número CIC</span>
                    <span class="api_log_detail_value">272727272</span>
                </div>
            </div>
            <div className="api_log_list">
                <h4>Detalles de Emisión</h4>
                <div class="api_log_detail">
                    <span>Número de Emisión</span>
                    <span class="api_log_detail_value">0</span>
                </div>
                <div class="api_log_detail">
                    <span>Año de Registro</span>
                    <span class="api_log_detail_value">2024</span>
                </div>
                <div class="api_log_detail">
                    <span>Año de Emisión</span>
                    <span class="api_log_detail_value">2024</span>
                </div>
                <div class="api_log_detail">
                    <span>Vigencia</span>
                    <span class="api_log_detail_value">31 de diciembre de 2034</span>
                </div>
            </div>
        </div>
    )
}

export default INEReport